module.exports = __webpack_public_path__ + "img/039.a2bdac9a.jpg";